import React, { useEffect, useState } from 'react';
import { deleteBankAccount, searchBankAccount } from '../../../api/sportaloka-client';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

function BankAccountTable() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const response = await searchBankAccount();
      const responseData = response.data.data;
      setData(responseData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: 'Apakah anda yakin?',
      text: 'Aksi ini tidak dapat dikembalikan',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Tetap lanjutkan!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          setData([]);
          await deleteBankAccount(id);
          await getData();
          Swal.fire({
            title: 'Berhasil!',
            text: `Promosi berhasil dihapus`,
            icon: 'success',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        } catch (error) {
          Swal.fire({
            title: 'Gagal!',
            text: `Periksa koneksi internet anda`,
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        }
      }
    });
  };

  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th style={{ width: '15%' }}>Nama Bank</th>
            <th style={{ width: '25%' }}>Nama Pemilik Rekening</th>
            <th style={{ width: '15%' }}>Nomor Rekening</th>
            <th style={{ width: '15%' }}>Tanggal Ditambahkan</th>
            <th className="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="6">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center" colSpan="6">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="6">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={getData}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td>{row.bank_name}</td>
              <td>{row.account_name}</td>
              <td>{row.account_number}</td>
              <td className="text-left">{format(new Date(row.created_at), 'dd/MM/yyyy')}</td>
              <td className="text-center pe-0">
                <Link
                  to={`/bank-account/detail/${row.id}`}
                  className="fw-500 text-blue-1 btn btn-primary text-white btn-sm border-blue-1 mr-10">
                  Ubah
                </Link>
                <button
                  onClick={() => handleDelete(row.id)}
                  className="fw-500 text-blue-1 btn btn-danger text-white btn-sm">
                  Hapus
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default BankAccountTable;
